import React from 'react';
import { Link } from 'react-router-dom';
import { Clock, MapPin, Calendar } from 'lucide-react';
interface BookingCardProps {
  price: string;
  priceDetail?: string;
  duration: string;
  format: string;
}
export function BookingCard({
  price,
  priceDetail,
  duration,
  format
}: BookingCardProps) {
  return <div className="bg-white p-8 rounded-2xl shadow-soft sticky top-32" data-id="element-58">
      <h3 className="text-2xl font-serif text-charcoal mb-6 border-b border-cream-200 pb-4" data-id="element-59">
        Session Details
      </h3>

      <div className="space-y-6 mb-8" data-id="element-60">
        <div className="flex items-start" data-id="element-61">
          <div className="bg-cream-50 p-3 rounded-full mr-4 text-sage-600" data-id="element-62">
            <Clock size={20} data-id="element-63" />
          </div>
          <div data-id="element-64">
            <p className="text-sm text-charcoal-50 font-medium mb-1" data-id="element-65">
              Duration
            </p>
            <p className="text-charcoal" data-id="element-66">{duration}</p>
          </div>
        </div>

        <div className="flex items-start" data-id="element-67">
          <div className="bg-cream-50 p-3 rounded-full mr-4 text-sage-600" data-id="element-68">
            <MapPin size={20} data-id="element-69" />
          </div>
          <div data-id="element-70">
            <p className="text-sm text-charcoal-50 font-medium mb-1" data-id="element-71">Format</p>
            <p className="text-charcoal" data-id="element-72">{format}</p>
          </div>
        </div>

        <div className="flex items-start" data-id="element-73">
          <div className="bg-cream-50 p-3 rounded-full mr-4 text-sage-600" data-id="element-74">
            <Calendar size={20} data-id="element-75" />
          </div>
          <div data-id="element-76">
            <p className="text-sm text-charcoal-50 font-medium mb-1" data-id="element-77">
              Investment
            </p>
            <p className="text-charcoal font-medium" data-id="element-78">{price}</p>
            {priceDetail && <p className="text-charcoal-50 text-sm font-light mt-1 leading-relaxed" data-id="element-79">
                {priceDetail}
              </p>}
          </div>
        </div>
      </div>

      <div className="space-y-4" data-id="element-80">
        <Link to="/contact" className="block w-full bg-sage text-white text-center py-3 rounded-full tracking-wide hover:bg-sage-600 transition-colors" data-id="element-81">
          Join a Session
        </Link>
        <Link to="/contact" className="block w-full border border-charcoal-50 text-charcoal-50 text-center py-3 rounded-full tracking-wide hover:bg-charcoal-50 hover:text-white transition-colors" data-id="element-82">
          Ask a Question
        </Link>
      </div>
    </div>;
}